import type { ReactNode } from 'react'
import Dialog from '@mui/material/Dialog'
import Box from '@mui/material/Box'
import type { SxProps, Theme } from '@mui/material/styles'
import {
  confirmationBackdropSx,
  confirmationPaperSx,
} from './confirmationModalStyles'

type Props = Readonly<{
  open: boolean
  onClose?: () => void
  dialogTestId?: string
  ariaLabelledBy?: string
  ariaDescribedBy?: string
  disableEscapeKeyDown?: boolean
  /** Merged onto the paper. Disables the default 600px dialog cap so wider layouts can apply. */
  paperSx?: SxProps<Theme>
  children: ReactNode
}>

export function ConfirmationModalShell({
  open,
  onClose,
  dialogTestId,
  ariaLabelledBy,
  ariaDescribedBy,
  disableEscapeKeyDown,
  paperSx,
  children,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={Boolean(paperSx)}
      maxWidth={paperSx ? false : 'sm'}
      disableEscapeKeyDown={disableEscapeKeyDown}
      aria-labelledby={ariaLabelledBy}
      aria-describedby={ariaDescribedBy}
      data-testid={dialogTestId}
      slotProps={{ backdrop: { sx: confirmationBackdropSx } }}
      PaperProps={{
        elevation: 0,
        sx: (paperSx
          ? [confirmationPaperSx, paperSx]
          : confirmationPaperSx) as SxProps<Theme>,
      }}
    >
      {children}
    </Dialog>
  )
}

export function ConfirmationModalLayout({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pt: '32px',
      }}
    >
      {children}
    </Box>
  )
}
